import React from 'react'
import { Box, IconButton, Text, Flex } from '@chakra-ui/react'
import { BiChat, BiUserPin } from 'react-icons/bi'
import { useDialerTab } from './dialer.hooks'
import { DialerTab } from '../contact-center.store'
import { HiPhone } from 'react-icons/hi'

type DialerFooterType = {}

export const DialerFooter: React.FC<DialerFooterType> = () => {
  const { tab, setTab } = useDialerTab()

  return (
    <Box background="#F2F7FE" h="55px" borderTop="1px solid #CBD5E0" w="100%">
      <Flex gap="35px" pt={2} ml="25px">
        <Box display="flex" flexDir="column" width="30%" cursor="pointer" onClick={() => setTab(DialerTab.CONTACT)}>
          <IconButton
            maxW="18px"
            maxH="18px"
            aria-label="icons"
            icon={<BiUserPin width="18px" height="18px" fontSize="18px" />}
            variant="unstyled"
            fontSize="18px"
            margin="auto"
            ml="10px"
            color={tab === DialerTab.CONTACT ? '#345EA6' : 'gray-600'}
          />
          <Text
            color={tab === DialerTab.CONTACT ? '#345EA6' : 'gray-600'}
            fontSize="9px"
            fontWeight="600"
            lineHeight="28px"
          >
            Contacts
          </Text>
        </Box>
        <Box display="flex" flexDir="column" width="30%" cursor="pointer" onClick={() => setTab(DialerTab.LOG)}>
          <IconButton
            maxW="18px"
            maxH="18px"
            aria-label="icons"
            icon={<HiPhone width="18px" height="18px" fontSize="14px" />}
            variant="unstyled"
            fontSize="18px"
            ml="3px"
            color={tab === DialerTab.LOG ? '#345EA6' : 'gray-600'}
          />
          <Text
            color={tab === DialerTab.LOG ? '#345EA6' : 'gray-600'}
            fontSize="9px"
            fontWeight="600"
            lineHeight="28px"
          >
            Logs
          </Text>
        </Box>
        <Box display="flex" flexDir="column" width="30%"  onClick={() => {
          //setTab(DialerTab.CHAT)
        }}>
          <IconButton
            maxW="18px"
            maxH="18px"
            aria-label="icons"
            icon={<BiChat width="18px" height="18px" fontSize="16px" />}
            variant="unstyled"
            fontSize="18px"
            margin="auto"
            color={tab === DialerTab.CHAT ? '#345EA6' : 'gray-600'}
            ml="5px"
            cursor="not-allowed"
          />
          <Text
            color={tab === DialerTab.CHAT ? '#345EA6' : 'gray-600'}
            fontSize="9px"
            fontWeight="600"
            lineHeight="28px"
          >
            Chats
          </Text>
        </Box>
      </Flex>
    </Box>
  )
}
